"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartsDateFilter = exports.ChartsDateFilterContextProvider = exports.ChartsDateFilterContext = void 0;
const common_1 = require("@components/common");
const FilterSelect_1 = require("@components/form/FilterSelect");
const locale_1 = __importDefault(require("@app/routes/Dashboard/locale"));
const Plate_1 = __importDefault(require("@components/common/Plate"));
const react_1 = __importStar(require("react"));
const useChartsDateFilterContext_1 = require("@app/routes/Dashboard/hooks/useChartsDateFilterContext");
const dateUtils_1 = require("@app/utils/dateUtils");
const initPeriod = 'month';
const initRange = (0, dateUtils_1.getPeriodRange)(initPeriod);
const initChartFilterState = Object.assign({ period: initPeriod }, initRange);
exports.ChartsDateFilterContext = react_1.default.createContext(null);
const ChartsDateFilterContextProvider = ({ children }) => {
    const [filterState, setFilter] = (0, react_1.useState)(initChartFilterState);
    return (react_1.default.createElement(exports.ChartsDateFilterContext.Provider, { value: { filterState, setFilter } }, children));
};
exports.ChartsDateFilterContextProvider = ChartsDateFilterContextProvider;
const ChartsDateFilter = () => {
    const { filterState, setFilter } = (0, useChartsDateFilterContext_1.useChartsDateFilterContext)();
    const handlePeriodChange = (ev) => {
        const { value } = ev.target;
        let datesUpdate = {};
        if (value !== 'unset') {
            const range = (0, dateUtils_1.getPeriodRange)(value);
            datesUpdate = {
                fromDate: range.fromDate,
                toDate: range.toDate
            };
        }
        setFilter(state => (Object.assign(Object.assign(Object.assign({}, state), { period: value }), datesUpdate)));
    };
    const handleDateFromChange = (ev) => {
        if (ev.target.value)
            setFilter(state => (Object.assign(Object.assign({}, state), { fromDate: ev.target.value, period: 'unset' })));
    };
    const handleDateToChange = (ev) => {
        if (ev.target.value)
            setFilter(state => (Object.assign(Object.assign({}, state), { toDate: ev.target.value, period: 'unset' })));
    };
    return react_1.default.createElement(Plate_1.default, { style: { position: 'relative', padding: '10px' } },
        react_1.default.createElement(common_1.Flex, { align: "center", w: "100%" },
            react_1.default.createElement("input", { type: "date", className: "input-date form-control", value: filterState.fromDate, onChange: handleDateFromChange }),
            react_1.default.createElement("span", { className: "date-range-delimiter" }, "-"),
            react_1.default.createElement("input", { type: "date", className: "input-date form-control", value: filterState.toDate, onChange: handleDateToChange }),
            react_1.default.createElement(FilterSelect_1.FilterSelect, { options: [
                    { name: locale_1.default.unset, value: 'unset' },
                    { name: locale_1.default.week, value: 'week' },
                    { name: locale_1.default.month, value: 'month' },
                    { name: locale_1.default.year, value: 'year' }
                ], onChange: handlePeriodChange, value: filterState.period })));
};
exports.ChartsDateFilter = ChartsDateFilter;
